var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5h9c.8 0 1.5-.7 1.5-1.5S19.3 2 18.5 2h-9C8.7 2 8 2.7 8 3.5S8.7 5 9.5 5zM18.5 8.5h-9C8.7 8.5 8 9.2 8 10s.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zM18.5 15h-9c-.8 0-1.5.7-1.5 1.5S8.7 18 9.5 18h9c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5zM4.5 1 2.9 3.2l-.5-.5c-.5-.4-1.2-.4-1.6.1-.4.5-.4 1.2.1 1.7l2 1.9c.1.1.3.2.4.1.1 0 .3-.1.4-.2l2.7-3.9c.4-.5.3-1.2-.2-1.6C5.5.3 4.8.5 4.5 1zM4.5 7 2.9 9.2l-.5-.5c-.5-.4-1.2-.4-1.6.1-.4.5-.4 1.2.1 1.7l2 1.9c.1.1.3.2.4.1.1 0 .3-.1.4-.2l2.7-3.9c.4-.5.3-1.2-.2-1.6-.7-.5-1.4-.3-1.7.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 16.5,
    r: 2.5
  })));
};
export default SvgTask;